exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contacttime-box{margin-bottom:30px}.contacttime-box label:first-child{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/contacttime/contacttime.styl
// module id = 70
// module chunks = 0 1